import React, {useEffect, useState} from "react"
import "./styles/index.css"
import Translate, {t} from "../../../../components/Translate";
import SearchInput from "../../../../components-new/form/SearchInput";
import BlueButton from "../../../../components-new/buttons/BlueButton";
import PlusIcon from "../../../../assets/icons/PlusIcon";
import {deleteGroup, fetchDepartments} from "../../../../services/internalGroups/api";
import LoadingComponent from "../../../../components-new/ui/LoadingComponent";
import DepartmentModal from "./components/DepartmentModal";
import DivisionModal from "./components/DivisionModal";
import {fetchCompanyOperators} from "../../../../services/company/api";
import config from "../../../../config";
import DepartmentAccordion from "./components/DepartmentAccordion";
import ConfirmationModal from "../../../../components-new/modals/ConfirmationModal";


const InternalGrouping = ({user, company, addNotification, ...rest}) => {

    const [search, setSearch] = useState("")
    const [departments, setDepartments] = useState([])
    const [isFetchingDepartments, setIsFetchingDepartments] = useState(false);

    const [departmentsModalType, setDepartmentsModalType] = useState("create");
    const [departmentsModalIsOpen, setDepartmentsModalIsOpen] = useState(false);
    const [selectedDepartment, setSelectedDepartment] = useState(null);

    const [divisionsModalType, setDivisionsModalType] = useState("create");
    const [divisionsModalIsOpen, setDivisionsModalIsOpen] = useState(false);
    const [selectedDivision, setSelectedDivision] = useState(null);
    const [selectedDepartmentId, setSelectedDepartmentId] = useState(null);

    const [users, setUsers] = useState(null);
    const [isFetchingUsers, setIsFetchingUsers] = useState(false);

    const [confirmationModalIsOpen, setConfirmationModalIsOpen] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [deletable, setDeletable] = useState(null);
    const filteredDepartments = departments.filter(d => d.name && d.name.toLowerCase().includes(search.toLowerCase()))

    useEffect(() => {
        setIsFetchingDepartments(true)
        fetchDepartments(company.id).then(response => {
            setDepartments(response)
        }).finally(() => setIsFetchingDepartments(false))
    }, [])

    const fetchUsers = () => {
        setIsFetchingUsers(true);
        fetchCompanyOperators(company.id).then(response => {
            setUsers(response)
        }).finally(() => setIsFetchingUsers(false))
    }
    const handleDelete = () => {
        if (!deletable) return
        setIsDeleting(true)
        deleteGroup(deletable.id, company.id).then(response => {
            if (response && response.success) {
                addNotification('deleted', config.notificationLevels.success)
            }
            setDepartments(prev => prev.filter(d => d.id !== deletable.id))
            setDepartments(prev => prev.map(dept => ({
                ...dept,
                divisions: dept.divisions.filter(div => div.id !== deletable.id)
            })))
            fetchUsers()
            setDeletable(null);
            setConfirmationModalIsOpen(false);
        }).catch(e => {
            const response = e.response.data
            addNotification(t({text: 'error.' + response.message, user}), config.notificationLevels.error)
        }).finally(() => {
            setIsDeleting(false)
        })
    }
    return (
        <div className="internal-grouping">
            <div className="internal-grouping__layout">
                {/* no padding here either; the toolbar starts on the page's
                    own line, level with everything under it */}
                <div className="internal-grouping__toolbar">
                    <SearchInput
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        containerStyle={{
                            minWidth: 0,
                            maxWidth: '400px',
                            flexGrow: 1
                        }}
                        style={{
                            height: '36px'
                        }}
                    />
                    <BlueButton
                        variant="soft"
                        width="auto"
                        height="36px"
                        onClick={() => {
                            if (!users && !isFetchingUsers) {
                                fetchUsers()
                            }
                            setDepartmentsModalType("create")
                            setDepartmentsModalIsOpen(true)
                        }}
                    >
                        <PlusIcon
                            width={18}
                            height={18}
                            stroke="currentColor"
                        />
                        <span>
                        <Translate text={'addDepartment'}/>
                    </span>
                    </BlueButton>
                </div>

                <div className="internal-grouping__list">
                    {isFetchingDepartments ?
                        <LoadingComponent/>
                        :
                        filteredDepartments.length === 0 ?
                            <div className="internal-grouping__empty">
                                <Translate text={'noResultsFound'}/>
                            </div>
                            :
                            <div>
                                {filteredDepartments.map(department =>
                                    <DepartmentAccordion
                                        key={department.id}
                                        department={department}
                                        onDeleteClick={(e) => {
                                            e.stopPropagation() // prevents accordion opening
                                            setDeletable(department)
                                            setConfirmationModalIsOpen(true)
                                        }}
                                        onEditClick={(e) => {
                                            e.stopPropagation() // prevents accordion opening
                                            if (!users && !isFetchingUsers) {
                                                fetchUsers()
                                            }
                                            setSelectedDepartment(department)
                                            setDepartmentsModalType("update")
                                            setDepartmentsModalIsOpen(true)
                                        }}
                                        onUpdateDepartment={updatedDepartment => {
                                            setDepartments(prev => prev.map(d => d.id === updatedDepartment.id ? updatedDepartment : d))
                                        }}
                                        onAddDivisionClick={(deptId) => {
                                            if (!users && !isFetchingUsers) {
                                                fetchUsers()
                                            }
                                            setSelectedDepartmentId(deptId)
                                            setDivisionsModalType("create")
                                            setDivisionsModalIsOpen(true)
                                        }}
                                        onEditDivisionClick={(division, deptId) => {
                                            if (!users && !isFetchingUsers) {
                                                fetchUsers()
                                            }
                                            setSelectedDivision(division)
                                            setSelectedDepartmentId(deptId)
                                            setDivisionsModalType("update")
                                            setDivisionsModalIsOpen(true)
                                        }}
                                        onDeleteDivisionClick={(division) => {
                                            setDeletable(division)
                                            setConfirmationModalIsOpen(true)
                                        }}
                                        company={company}
                                    />
                                )}
                            </div>
                    }
                </div>

                <DepartmentModal
                    isOpen={departmentsModalIsOpen}
                    type={departmentsModalType}
                    closeModal={() => setDepartmentsModalIsOpen(false)}
                    company={company}
                    user={user}
                    users={users}
                    department={selectedDepartment}
                    addNotification={addNotification}
                    isFetchingUsers={isFetchingUsers}
                    onSuccess={(newDepartment) => {
                        setDepartments(prev => {
                            const exists = prev.some(d => d.id === newDepartment.id)

                            if (exists) {
                                return prev.map(d => d.id === newDepartment.id ? newDepartment : d)
                            }

                            return [newDepartment, ...prev]
                        })
                        fetchUsers()
                        setDepartmentsModalIsOpen(false)
                    }}
                />

                <DivisionModal
                    isOpen={divisionsModalIsOpen}
                    type={divisionsModalType}
                    closeModal={() => setDivisionsModalIsOpen(false)}
                    company={company}
                    user={user}
                    users={users}
                    division={selectedDivision}
                    departmentId={selectedDepartmentId}
                    addNotification={addNotification}
                    isFetchingUsers={isFetchingUsers}
                    onSuccess={(newDivision, deptId) => {
                        setDepartments(prev => prev.map(dept => {
                            if (dept.id === deptId) {
                                const divisions = dept.divisions || [];
                                const exists = divisions.some(d => d.id === newDivision.id);
                                return {
                                    ...dept,
                                    divisions: exists
                                        ? divisions.map(d => d.id === newDivision.id ? newDivision : d)
                                        : [newDivision, ...divisions]
                                };
                            }
                            return dept;
                        }));
                        fetchUsers()
                        setDivisionsModalIsOpen(false);
                    }}
                />

                <ConfirmationModal
                    variant="delete"
                    isOpen={confirmationModalIsOpen}
                    onClose={() => setConfirmationModalIsOpen(false)}
                    onConfirm={handleDelete}
                    message={t({text: "areYouSureYouWantToProceed", user})}
                    loading={isDeleting}
                />
            </div>
        </div>
    )
}


export default InternalGrouping



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/internal-grouping/InternalGrouping.jsx